export var WEB_SDK_SOURCE = 'YandexTrustWebSDK';
